'use client';

import { useState } from 'react';

import { ResendInvitationForm } from '@/components/forms';
import { ModalWrapper } from '@/components/organisms/ModalWrapper';
import { SendInvitationData } from '@/entities';

interface ResendInvitationModalProps {
	firstName: string;
	lastName: string;
	teamName: string;
	invitationCode: string;
}

export const ResendInvitationModal = ({ firstName, lastName, teamName, invitationCode }: ResendInvitationModalProps) => {
	const [showModal, setShowModal] = useState<boolean>(false);

	const toggleModal = () => {
		setShowModal((prev) => !prev);
	};

	const handleFormSubmit = (_data: SendInvitationData) => {
		console.log('Form Data:', _data);
		toggleModal();
	};

	return (
		<>
			<button onClick={toggleModal}>show modal for invitation</button>

			{showModal && (
				<ModalWrapper className="!max-w-[475px]  !gap-0" title="Resend invitation" onClose={toggleModal} closeOnOutsideClick={true}>
					<ResendInvitationForm
						firstName={firstName}
						lastName={lastName}
						teamName={teamName}
						invitationCode={invitationCode}
						onSubmit={handleFormSubmit}
						onClose={toggleModal}
					/>
				</ModalWrapper>
			)}
		</>
	);
};
